/*eslint-disable*/ export const messages = { New: "Новое", "Remove {label}": ["Удалить ", ["label"]] };
